if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slideshow__controls');
      this.sliderItems = this.querySelectorAll('.slideshow__slide');
      this.pageCount = this.querySelectorAll('.slider-counter__link');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.slider = this.querySelector('.slideshow');
      this.sliderCurrentPage = this.querySelector('.slider-counter--current');
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      
      if (!this.slider || !this.sliderItems.length) return;
      
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
      this.currentPage = 0;
      
      this.initializeSlides();
      this.addEventListeners();
      
      if (this.slider.dataset.autoplay === 'true') {
        this.setAutoPlay();
      }
    }

    initializeSlides() {
      // Set initial position for all slides
      this.sliderItems.forEach((slide, index) => {
        slide.style.position = 'absolute';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';
        slide.style.height = '100%';
        slide.style.opacity = index === 0 ? '1' : '0';
        slide.style.transition = 'opacity 0.5s ease-in-out';
        slide.style.zIndex = index === 0 ? '1' : '0';
      });

      // Ensure slider container has relative positioning
      if (this.slider) {
        this.slider.style.position = 'relative';
      }

      // Set first page counter as active
      if (this.pageCount.length > 0) {
        this.pageCount[0].classList.add('slider-counter__link--active');
      }
    }

    addEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      
      if (this.sliderAutoplayButton) {
        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      }

      this.pageCount.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.setSlide(index);
        });
      });

      // Pause on hover
      if (this.slider.dataset.autoplay === 'true') {
        this.slider.addEventListener('mouseenter', () => {
          if (this.autoplayButtonIsSetToPlay) {
            clearTimeout(this.autoplay);
          }
        });

        this.slider.addEventListener('mouseleave', () => {
          if (this.autoplayButtonIsSetToPlay) {
            this.play();
          }
        });
      }

      // Add keyboard navigation
      this.slider.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.setSlide(this.currentPage - 1);
        } else if (e.key === 'ArrowRight') {
          this.setSlide(this.currentPage + 1);
        }
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.name === 'next' ? 1 : -1;
      this.setSlide(this.currentPage + step);
    }

    setSlide(index) {
      // Handle wrap around
      if (index >= this.sliderItems.length) {
        index = 0;
      }
      if (index < 0) {
        index = this.sliderItems.length - 1;
      }

      // Hide current slide
      this.sliderItems[this.currentPage].style.opacity = '0';
      this.sliderItems[this.currentPage].style.zIndex = '0';

      // Update current page
      this.currentPage = index;

      // Show new slide
      this.sliderItems[this.currentPage].style.opacity = '1';
      this.sliderItems[this.currentPage].style.zIndex = '1';

      // Update counter
      this.updateCounter();

      // Restart autoplay if active
      if (this.autoplayButtonIsSetToPlay) {
        clearTimeout(this.autoplay);
        this.play();
      }

      // Update aria-live region
      this.slider.setAttribute('aria-live', 'polite');
    }

    updateCounter() {
      // Update numeric counter
      if (this.sliderCurrentPage) {
        this.sliderCurrentPage.textContent = this.currentPage + 1;
      }

      // Update dots/numbers
      this.pageCount.forEach((button, index) => {
        if (index === this.currentPage) {
          button.classList.add('slider-counter__link--active');
          button.setAttribute('aria-current', 'true');
        } else {
          button.classList.remove('slider-counter__link--active');
          button.removeAttribute('aria-current');
        }
      });
    }

    setAutoPlay() {
      this.autoplayButtonIsSetToPlay = true;
      if (this.sliderAutoplayButton) {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      }
      this.play();
    }

    play() {
      this.autoplay = setTimeout(() => {
        this.setSlide(this.currentPage + 1);
      }, this.autoplaySpeed);
    }

    autoPlayToggle() {
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
      
      if (this.sliderAutoplayButton) {
        this.sliderAutoplayButton.classList.toggle('slideshow__autoplay--paused');
        
        const pauseLabel = this.sliderAutoplayButton.getAttribute('aria-label');
        const playLabel = pauseLabel.includes('pause') 
          ? pauseLabel.replace('pause', 'play')
          : pauseLabel.replace('play', 'pause');
        this.sliderAutoplayButton.setAttribute('aria-label', playLabel);
      }

      if (this.autoplayButtonIsSetToPlay) {
        this.play();
      } else {
        clearTimeout(this.autoplay);
      }
    }

    // Clean up on disconnect
    disconnectedCallback() {
      if (this.autoplay) {
        clearTimeout(this.autoplay);
      }
    }
  });
}